import React, {useEffect, useState} from 'react';
import {Button, Col, Modal, Row} from 'react-bootstrap';
import DataTable from '../../../../common/DataTable';
import SearchableSingleSelectDropdown from '../../../../common/SearchableDropdown';
import Snackbar from '../../../../common/Snackbar';
import {
  GetAssignedToReviewerList,
  updateRecordReviewerAssignedTo,
} from '../../../../services/RecordReviewerAPI';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../redux/Store';

const HEADERS: any[] = [
  {key: 'caseId', label: 'Case Id'},
  {key: 'patientName', label: 'Patient Name'},
  {key: 'qmeDoctorName', label: 'Doctor Name'},
];

const AssignToRecordReviewer: React.FC<any> = ({
  reviewerData,
  showDrawer,
  onClose,
  caseInfoId,
  caseId,
}) => {
  const [contactUserId, setContactUserId] = useState(0);
  const [userOptions, setUserOptions] = useState<any[]>([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [error, setError] = useState('');
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);

  const fetchAssignedToListData = async () => {
    try {
      const response = await GetAssignedToReviewerList(Number(loggedInUserid));
      if (response?.isSuccess && Array.isArray(response.result)) {
        const formattedOptions = response.result.map((item: any) => ({
          value: item.userId,
          label: item.fullName,
        }));
        setUserOptions(formattedOptions);
        if (reviewerData.length > 1) {
          setContactUserId(Number(loggedInUserid));
        } else {
          const assignedToUserId = reviewerData
            ?.map((item: any) => item.assignedToUserId)
            .filter((id: any) => id != null)
            .join(',');
          setContactUserId(Number(assignedToUserId));
        }
      } else {
        setUserOptions([]);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setUserOptions([]);
    }
  };
  useEffect(() => {
    fetchAssignedToListData();
  }, []);

  const handleSave = async () => {
    const subjectQmeScheduleIDNew = reviewerData
      ?.map((item: any) => item.subjectQmeScheduleId)
      .filter((id: any) => id != null)
      .join(',');

    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');

    const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:00`;

    const payload = {
      subjectQMEScheduleIds: subjectQmeScheduleIDNew,
      rorAssignedUserID: Number(contactUserId),
      rorcomments: '',
      rorAssignedDate: formattedDate,
    };

    try {
      if (contactUserId == null) {
        setSnackbarMessage('Please select user');
        setError('error');
        setSnackbarOpen(true);
        return;
      }

      const response = await updateRecordReviewerAssignedTo(payload);
      if (response.isSuccess) {
        setSnackbarMessage('Assigned to reviewer successfully.');
        setError('success');
        setSnackbarOpen(true);
        setTimeout(() => {
          onClose();
        }, 800);
      } else {
        setSnackbarMessage(
          response.message || 'Failed to Save Assign To Reviewer.',
        );
        setError('error');
        setSnackbarOpen(true);
      }
    } catch (error: any) {
      console.error('Error while updating assigned To:', error);
      setSnackbarMessage(error.message);
      setError('error');
      setSnackbarOpen(true);
    }
  };

  const handleReset = () => {
    setContactUserId(0);
  };

  return (
    <div className=' d-flex flex-column h-100'>
      <Snackbar
        open={snackbarOpen}
        message={snackbarMessage}
        onClose={() => setSnackbarOpen(false)}
        severity={error}
      />

      {reviewerData?.length > 1 ? (
        <>
          To whom do you want to assign selected{' '}
          <span style={{color: '#6bb3d4', margin: '0 4px'}}>
            {reviewerData?.length}
          </span>{' '}
          case(s)?
        </>
      ) : (
        <b>To whom do you want to assign below case(s)?</b>
      )}

      <Row className='mt-3'>
        {reviewerData?.length === 1 && (
          <DataTable headers={HEADERS} rows={reviewerData} isLogTable={false} />
        )}
      </Row>
      <Row>
        <Col sm={12} className='selection_dropdown selection_dropdownnew mt-3 '>
          <SearchableSingleSelectDropdown
            label='Select User'
            name='contactUserId'
            required={true}
            value={contactUserId}
            options={userOptions}
            onChange={(e) => setContactUserId(Number(e.target.value))}
          />
        </Col>
      </Row>
      <Row id='team-form-buttons' className='bottom-fixed-btn mt-auto'>
        <Col md={6} className='d-flex justify-content-start mb-0 '></Col>
        <Col md={6} className='d-flex justify-content-end mb-0 px-0 pe-0'>
          <Button
            variant='outline-info'
            className='d-flex align-items-end'
            onClick={handleReset}
          >
            <span className='material-icons mr-2'>close</span> Cancel
          </Button>
          <Button
            variant='primary'
            className='ms-3 d-flex align-items-center'
            onClick={handleSave}
          >
            <span className='material-icons mx-1'>save</span> Save
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default AssignToRecordReviewer;
